import { render, staticRenderFns } from "./TriangleRewardsCard.vue?vue&type=template&id=3691c919&scoped=true"
import script from "./TriangleRewardsCard.vue?vue&type=script&lang=js"
export * from "./TriangleRewardsCard.vue?vue&type=script&lang=js"
import style0 from "./TriangleRewardsCard.vue?vue&type=style&index=0&id=3691c919&prod&lang=scss&scoped=true"
import style1 from "./TriangleRewardsCard.vue?vue&type=style&index=1&id=3691c919&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3691c919",
  null
  
)

export default component.exports